import React, { useEffect, useState } from "react";
import { ImageProps } from "next/image";
import Image from "@Components/Image";

type ImageFormat = "webp" | "png" | "jpg" | "jpeg";

export interface ContentfulImageProps extends Partial<ImageProps> {
  src: string;
  alt: string;
  format?: ImageFormat;
}

export const ContentfulImage = ({
  src,
  alt = "",
  format = "webp",
  ...rest
}: ContentfulImageProps) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setScreenWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!src) return null;

  const imageUrl = buildImageUrl({ screenWidth, src, format });

  return <Image src={imageUrl} alt={alt} {...rest} />;
};

const buildImageUrl = ({
  screenWidth,
  src,
  format = "webp",
}: {
  screenWidth: number;
  src: string;
  format?: ImageFormat;
}) => {
  const minImageWidth = 720;
  const maxImageWidth = 1600;
  const imageWidth = Math.max(
    minImageWidth,
    Math.min(screenWidth, maxImageWidth)
  );
  const ratio = 16 / 9;
  const imageHeight = Math.round(imageWidth / ratio);

  return `${src}?fm=${format}&w=${imageWidth}&h=${imageHeight}`;
};
